import React from 'react';

function INIcon({ w, h, style, className }) {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 512 512"
      style={style}
    >
      <circle cx={256} cy={256} r={256} fill="#f0f0f0" />
      <path
        d="M256 0C154.506 0 66.81 59.065 25.402 144.696h461.195C445.19 59.065 357.493 0 256 0z"
        fill="#ff9811"
      />
      <path
        d="M256 512c101.493 0 189.19-59.065 230.598-144.696H25.402C66.81 452.935 154.506 512 256 512z"
        fill="#6da544"
      />
      <circle cx={256} cy={256} r={89.043} fill="#0052b4" />
      <circle cx={256} cy={256} r={55.652} fill="#f0f0f0" />
      <path
        fill="#0052b4"
        d="M256 187.326l17.169 38.938 42.304-4.601L290.337 256l25.136 34.337-42.304-4.601L256 324.674l-17.169-38.938-42.304 4.6L221.663 256l-25.136-34.337 42.304 4.601z"
      />
    </svg>
  );
}

INIcon.defaultProps = {
  w: 18,
  h: 18,
  style: {},
  fill: '#000000',
};

export default INIcon;
